import { Controller } from "@hotwired/stimulus"

// GL Accordion — lightweight expand/collapse for .gl-accordion
// Usage: data-controller="accordion" on the .gl-accordion wrapper
//        data-action="click->accordion#toggle" on each .gl-accordion-header
export default class extends Controller {
  toggle(event) {
    const header = event.currentTarget
    const item = header.closest(".gl-accordion-item")
    const body = item.querySelector(".gl-accordion-body")
    if (!body) return

    const isOpen = body.classList.contains("is-open")

    if (isOpen) {
      body.classList.remove("is-open")
      item.classList.remove("is-expanded")
      header.setAttribute("aria-expanded", "false")
    } else {
      body.classList.add("is-open")
      item.classList.add("is-expanded")
      header.setAttribute("aria-expanded", "true")
    }
  }
}
